/* eslint-disable */
import React from "react";
import { useParams } from "react-router-dom";
import HelmetTemplate from "../utils/HelmetTemplate";
import WebpageShell from "./WebpageShell";

import PhotoCarousel from "../components/PhotoCarousel";
import ReviewerDetails from "../components/ReviewerDetails";
import ReviewText from "../components/ReviewText";

export default function Review() {
  const { reviewId } = useParams();

  return (
    <WebpageShell
      navProps={{ addAnnouncementBar: false, isRecPrototypePage: false }}
      showCTA={true}
      showFooter={true}
    >
      <HelmetTemplate
        title="Review - Match Medic"
        description="Welcome to Match Medic – Find the right hair transplant clinic for your unique needs. Cut through the noise and misinformation surrounding hair transplants. Our algorithm will recommend the clinics with the best track record for your unique needs within seconds."
        canonicalUrl={`https://matchmedic.com/review/${reviewId}`}
      />

      {/* Page container (desktop stays contained; mobile wrapper below will create full-bleed) */}
      <div className="w-full md:w-4/5 mx-auto md:pt-10 pb-10">
        {/* Photo carousel: unchanged on all sizes */}
        <PhotoCarousel docId={reviewId} />

        {/* Reviewer details — full-bleed on mobile, contained on md+ */}
        <div className="mt-8 mx-[calc(50%-50vw)] w-screen md:mx-0 md:w-auto">
          <ReviewerDetails docId={reviewId} />
        </div>

        {/* Review text — full-bleed on mobile, contained on md+ */}
        <div className="mt-8 mx-[calc(50%-50vw)] w-screen md:mx-0 md:w-auto">
          <ReviewText reviewId={reviewId} />
        </div>
      </div>
    </WebpageShell>
  );
}
